export default "__VITE_ASSET__IMYHUDb5__"